export const defaultTheme = {
  color: {
    'dark': '#323232',
    'gray': '#707070',
    'lightgray': '#F6F6F6',
    'primaryblue': '#EB5A25',
    'primaryhover': '#D44E1D',
    'secondaryhover': '#FDF2ED',
    'white': '#FFFFFF',
    'bordergray': '#C1C1C1',
    'disabledgray': '#E9E9E9',
    'warning': '#DB0640',
    'warninghover': '#FF2B64',
    'lightwarning': '#FFBBD0',
  },
  fonts: {
    'SegoeUI': 'Segoe UI'
  },
}
